export default __webpack_public_path__ + "static/media/appStatusLOApproved.361b984e.png";